module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_27",
      "title": "27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "CTT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Sacker-Light-Italic"
  }, [_vm._v("LA PARISIENNE")])])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" … all snobbery is about the problem of belonging.")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("LEXANDER")]), _vm._v(" T"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("HEROUX")]), _vm._v(", American novelist")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Florence, aged sixteen, thought of herself as "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("La Parisienne")]), _vm._v(", that gigantic statue representing modernity, fashion, and glamour at the Exposition Universelle of 1900. The statue, sculpted by Paul Moreau-Vauthier, was the exhibition’s focal point. All visitors walked into the Paris fairgrounds through the Porte Monumentale, where they were greeted by this female colossus, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("La Parisienne")]), _vm._v(", in all her glory. She was modern, like Paris, stunningly beautiful, outfitted in Jeanne Paquin’s haute-couture gown. She was quintessentially French. She was no Marianne, the allegorical, martial, patriotic symbol of France. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("La Parisienne")]), _vm._v(" invited all visitors, French and foreign, to enter and see a new, contemporary Paris, released from the shackles of tradition and the scandals of the Third Republic, to revel in the excitement that Paris represented to the world in culture, invention, and science."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-1",
      "id": "notes-ch3_1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Florence saw herself as a living, breathing "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("La Parisienne")]), _vm._v(", modern, glamorous, sexy, a future Gaby Deslys, star of the Folies Berg"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("è")]), _vm._v("re. Unlike Gaby, Florence wanted to find her feet in the rarefied world of opera. While she learned only about "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("La Parisienne")]), _vm._v(" in school, Florence could easily relate to both "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("La Parisienne")]), _vm._v(" and the designer of her haute couture, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_28",
      "title": "28"
    }
  }, [_vm._v("Jeanne Paquin. The House of Paquin was the rising star in the fashion world, noted for wooing away clients from the aristocratic, traditional designs of Gaston Worth. Despite Paquin’s short ascendency, she eclipsed the established, male House of Worth with her daring and innate feminine understanding of what women wanted to wear. Beautiful in her own right, Paquin had risen from humble origins to become first a model, then a designer, and finally the owner of her own fashion house. It was that kind of upward mobility that Florence admired and yearned to emulate, up to a point."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-2",
      "id": "notes-ch3_2"
    }
  }, [_vm._v("2")])]), _vm._v(" Where Paquin was happy for her fashions to shine in the limelight, Florence needed the oxygen of the limelight shining directly on her.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By 1900, money, or the lack of it, had become a gradually determining factor in social status. While land ownership still mattered, and marked an enviable noble heritage, the landed gentry throughout Europe were finding the new, raw capitalism of the early twentieth century hard to fathom, and harder still to adopt. The titled aristocracy were on the hunt for American heiresses born to wealthy robber barons of the ilk of the Vanderbilts, Morgans, and Goulds; or even, if the need absolutely dictated, daughters born to manufacturing giants like Isaac Merritt Singer, inventor of the first evenly stitching sewing machine."), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-19024-1",
      "id": "footnote-19024-1-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In Florence’s Paris, it was a commonly known fact that all Americans were equally unacceptable in society, but their money was a necessary evil to be envied and plundered, so European aristocracy could plow on regardless. It was the American search and need for belonging in European society, coupled with the European requirement for new money, that changed many heiresses’ and aristocrats’ futures. Consuelo Vanderbilt was coerced into her marriage with the Duke of Marlborough by her mother, saving Blenheim Palace and the duke’s other assets from oblivion. Marie Alice Heine, born in the French Quarter of New Orleans to a Jewish banking family, converted to Roman Catholicism to become the Duchess of Richelieu. When Alice was widowed as a young woman still of childbearing age, she remarried well, becoming Her Serene High"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_29",
      "title": "29"
    }
  }, [_vm._v("ness of Monaco, Princess Alice."), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-19024-2",
      "id": "footnote-19024-2-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" Jennie Jerome, the first American-dollar “princess,” and mother of Sir Winston Churchill, also gave her inherited fortune to underpin her husband’s political career for the dubious pleasure of becoming Lady Randolph Churchill.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Florence ached to belong to the treasured circle of these elite society women, but despite her private school education, she lacked the money and connections to meet, much less marry into, such illustrious circles. While Charles Loeb toiled to obtain satisfaction through the California courts, Florence was, momentarily, relatively penniless. Dreams were one thing, reality quite another. Still, the sixteen-year-old was already a remarkable beauty, and knew it. Florence had also become a frightful snob—something everyone who met her remarked upon—and could not see herself living forever in obscurity, much less in poverty.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Certainly, Berthe instilled in her daughter an awareness that such beauty should provide Florence—and by extension her family—with an international passport to glamour, wealth, and happiness. As for the protagonist in the story "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Gigi,")]), _vm._v(" written by Florence’s near contemporary, the French author Colette, it was Florence’s duty to marry well and share her newfound wealth with the family. For Berthe, while it mattered if Florence’s future was that of a demimondaine or an opera singer or the wife of a millionaire, she was a practical woman. If Florence could not marry well, then a world-famous opera singer would be her next choice for her daughter. Failing that, Florence would need to consider becoming a successful demimondaine.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The searing question was, could Florence marry well? Florence’s world was changing rapidly. By 1913, the first self-made millionairess was a Polish Jew, Helena Rubinstein. Rubinstein had become rich from her mail-order business, which sold face cream to sun-ravaged Australian women in the Outback. Now Rubinstein owned beauty salons in Melbourne, London, and Paris and was searching for a salon in New York. “Beauty is power” was an early Rubinstein advertising slogan, and Florence decided that her beauty might provide her big break into the international high-society set of Paris."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-3",
      "id": "notes-ch3_3"
    }
  }, [_vm._v("3")])]), _vm._v(" While Florence thought she had "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_30",
      "title": "30"
    }
  }, [_vm._v("the business sense to run an international company like Rubinstein’s, it was not, yet, her passion, and it remained an unproven skill for some years to come.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Society and glamour, on the other hand, consumed her every waking hour. Back then, glamour was not about cosmetics and a slash of red lips for Florence. That was for later, when it became the fashion. It was about power, sexuality, and the unadulterated pleasure it could bring her. It was about luxury and excess. It was about living without the conventions or expectations of classical femininity. Above all, it was about heady sensuality and reveries beyond the ordinary, creating her own boldness, her own world of risk and self-assertion, and tipping the scales of an unequal male society in her favor. If her beauty could give her a leg up into that society so she could create her own world of glamour, so much the better. Certainly, her other great asset—her singing voice—gave another string to her bow, creating an aura of the exotic, the dangerously alluring.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Even at sixteen, Florence was a young woman on a mission. She combed the society columns, soaked in every bit of gossip and news about "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("le Tout-Paris")]), _vm._v("—the city’s fashionable elite—and gleaned every crumb she could about the public and private lives of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("salonnières")]), _vm._v(" (society hostesses) who might be susceptible to her charms. So, when she thought she was ready, Florence cajoled her old music professor into introducing her into the salon society. Alas, it seemed that the professor was found wanting in his connections to the salonni"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("è")]), _vm._v("res whom Florence was determined to know. Perhaps, too, Berthe could no longer afford his lessons, and hence his failure to do as he was bid. But Florence would not be defeated. It seemed only natural that she should try to cultivate the American salonni"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("è")]), _vm._v("res who had made Paris their home. Aside from her near neighbor Gertrude Stein, who was dowdy, masculine, and perhaps hideous to Florence’s beautiful green eyes, there were, fortunately, others.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("The American playwright, novelist, and poetess Natalie Clifford Barney held her court at 20 rue Jacob on the Left Bank within easy walking distance of Florence’s home. Natalie was born in Dayton, Ohio, in 1876—nine years before Florence’s birth in San Francisco. Natalie’s father had "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_31",
      "title": "31"
    }
  }, [_vm._v("become fabulously wealthy as the manufacturer of railway cars for most of the railroads that linked the east and west coasts of America. Her mother, Alice Pike Barney, had been encouraged to take her painting seriously by Oscar Wilde, and later studied art under the guidance of James McNeill Whistler."), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-19024-3",
      "id": "footnote-19024-3-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Having spent years in England and France, Natalie felt that puritanical America would never appreciate her artistic and lesbian leanings, and so she decamped from the USA and moved with her huge inheritance in tow to Paris. Her “Fridays,” as her salons were called, positively dripped with panache and flair, exuding their influence on a carefully stage-managed setting. For sixty years, she influenced the literati of France, Britain, and America. Later, Truman Capote, who had become a regular after the Second World War, described Barney’s Fridays as “a cross between a chapel and a bordello.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-4",
      "id": "notes-ch3_4"
    }
  }, [_vm._v("4")])]), _vm._v(" Favorites in the pre–Great War era included Oscar Wilde, Sinclair Lewis, Gertrude Stein, the influential Bohemian-Austrian poet and novelist Rainer Maria Rilke, T. S. Eliot, and Isadora Duncan, as well as Barney’s Symbolist poetess lover Ren"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("e Vivien.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Barney’s exquisite social mix of the intelligentsia with her outrageous and philosophical regulars was legend. Openly lesbian, she helped make lesbianism fashionable in 1900s cultured Paris. Even more extraordinary was that she was the first woman poet since Sappho to write openly about her love of other women. Barney loved the theater of her Fridays, and made those whom she liked share in her theatrical events. Once, she had herself delivered to her lover Ren"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("e Vivien in a box of lilies, alluringly attired for the boudoir. A headline-grabbing moment that Florence would have spotted in the papers, and probably rolled about laughing with her friend C"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("cile Tellier as they gasped and groaned for breath, was the reported entrance of the exotic dancer and courtesan Mata Hari, not yet infamous as a treacherous spy, to one of Barney’s Fridays. The society column inches were flush with reports that Mata Hari daringly appeared in her birthday suit as Lady Godiva astride a white stallion as a prelude to her exotic performance.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_32",
      "title": "32"
    }
  }, [_vm._v("Florence might have been attracted to Barney’s Fridays. They would certainly have given her an opportunity, as a salon chanteuse, to meet the rich, the powerful, and the famous. Still, was Florence willing to throw herself into the path of a notable lesbian who was then mourning the death of her British lover, Ren"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("e Vivien?"), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-19024-4",
      "id": "footnote-19024-4-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" Always plucky, and still lighthearted, Florence may have had second thoughts. There were other salonni"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("è")]), _vm._v("res, other Americans.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Perhaps Anna Gould? She was also an American railroad heiress, with a bit of a checkered past. By 1912, Anna was on her second French husband and was known as the Duchess de Sagan. In 1893, Anna had been engaged to Oliver Harriman, a cousin of the railroad magnate Edward Harriman, a close friend of Anna’s brother George. In the spring of 1894, she went to Paris to buy her wedding trousseau at the House of Worth, and take up an introduction to Miss Anna Reed, who ran a Paris salon designed to “finish” American heiresses with "), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("lan. Reed introduced Anna to the Duc de Talleyrand-P"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("rigord and his young cousin, the Count Marie Paul Ernest Boniface de Castellane, whom everyone called “Boni.” By then, Anna had fallen in love with the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ésprit parisien")]), _vm._v(" and mistook the counterfeit Boni for the genuine article. For Castellane, neither Anna’s warts nor her clubfoot stood in the way of his pursuit of her eight-figure inheritance. In record time, Boni proposed marriage in anticipation of spending Anna’s millions. Against the Gould family’s wishes, Anna broke off her engagement to the young Harriman. After much family displeasure, she married the gambling, womanizing, at times bellicose Castellane. No wonder the marriage became Edith Wharton’s inspiration for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Buccaneers.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Alas for Boni, shortly before the wedding day in New York, the Gould family sprang a trap and demanded his signature on a marriage contract. As distasteful as it was for the cash-strapped Castellane, he had no alternative than to obey. After all, his creditors, too, had already spent Anna’s millions. But neither he nor his creditors realized whom they "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_33",
      "title": "33"
    }
  }, [_vm._v("were dealing with: Anna maintained full control of her portion of the Gould family trust."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-5",
      "id": "notes-ch3_5"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By 1907, the Castellanes’ internationally publicized divorce filled the society pages in France and the United States. Apparently, Boni had somehow managed to put Anna some $4.5 million in debt,"), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-19024-5",
      "id": "footnote-19024-5-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" mostly in building their “pink palace” on avenue Malakoff. The family trust had to bail her out, but only on the proviso that her brother George become her official civil trustee in Paris, to prevent Boni from leeching more money from the estate."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-6",
      "id": "notes-ch3_6"
    }
  }, [_vm._v("6")])]), _vm._v(" Upon their divorce, Boni received a settlement of $250,000 and an annual income of $30,000—approximately a lump-sum payment of $6.11 million and annual income of $733,000 in today’s money—from Anna’s portion of the trust. Two years later, believing that she had secured a dispensation from Rome to marry Boni’s cousin, the wealthy H"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("lie de Talleyrand-P"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("rigord, Duc de Talleyrand and Prince de Sagan, Anna Gould of Tarrytown, New York, became a French duchess.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("While Florence might have also read about Anna Gould’s brother Frank Jay Gould, who was embroiled in his first divorce about the same time, it was Anna who attracted her eye. How could such an unattractive but wealthy woman, whose family had been shunned by the social set of New York for dozens of years, marry twice? Hadn’t Anna recently been described by the Parisian Symbolist poet and aesthete Robert de Montesquiou as having “the eyes of a captured chimpanzee”?"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-7",
      "id": "notes-ch3_7"
    }
  }, [_vm._v("7")])]), _vm._v(" No, Anna’s salon, while hosting the aristocracy of Parisian society, would be too dull for Florence Lacaze. If there was one thing she was determined to have, it was excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Unless or until the family’s finances were on a sounder footing, Florence simply had to either marry her millions or sing for her living. Still, there was one American living in Paris who had the potential to offer Florence both. Winnaretta—“Winnie” to her friends—the Princesse de Polignac, held a salon dedicated to music and the arts in her home on avenue Henri-Martin on the Right Bank. Born in Yonkers, New York, Winnie embodied all that Florence hungered to be: wealthy, musical, and the throbbing heart of society.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_34",
      "title": "34"
    }
  }, [_vm._v("Winnie’s inherited wealth came from her father, Isaac Merritt Singer, and his sewing machines. Her mother was the beautiful and musical Isabella Eug"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("nie Boyer, thirty years her father’s junior. Winnaretta was their second child, born at the end of the Civil War in 1865."), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-19024-6",
      "id": "footnote-19024-6-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" Her first memories, however, were of southern England. Just before the Franco-Prussian War of 1870–71, Isaac Singer emigrated from France to England, buying a home in London’s Grosvenor Square and a sprawling estate in Paignton, Devon, which he ironically christened “The Wigwam.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When her father died, the ten-year-old Winnie returned to Paris to live with her mother and siblings. After a brief and incompatible marriage to Prince Louis de Scey-Montb"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("liard, at the age of twenty-two, which Winnie had agreed to merely to be released from her mother’s overbearing guardianship, Winnie made it known that she would never again be dominated by another person."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-8",
      "id": "notes-ch3_8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Newly divorced, Winnaretta—more frequently than not called “Madame Singer” by high society—established her own avant-garde music salon. She also began traveling widely throughout Europe, indulging herself in the luxury of escape. But eighteen months later, she unexpectedly agreed to marry Prince Edmond de Polignac. Why? He was a suspected homosexual and nearly thirty years her senior. True, his father was the son of Marie-Antoinette’s beloved friend Yolande, Duchesse de Polignac. Still, French high society mocked the union in loud stage whispers. It was yet another unsuitable marriage. What le Tout-Paris hadn’t known at the time was that Winnaretta was a confirmed lesbian. The marriage was a highly successful and affectionate one and may not have been a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("marriage blanc")]), _vm._v(" (unconsummated). While the role of women was changing rapidly, it was thought impossible for a divorced woman—no matter how much money she had—to become a successful salonni"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("è")]), _vm._v("re. Winnaretta’s all-too-short marriage to Edmond was a happy one, ending abruptly with Edmond’s death in August 1901.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Unlike Natalie Barney’s Fridays, Winnaretta, Princesse de Polignac, held her salon on the days that suited her performers. She had a lifelong "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_35",
      "title": "35"
    }
  }, [_vm._v("devotion to Wagner’s music. Equally, she wanted to promote baroque music and the neglected genius of Handel and Bach. What especially interested Florence was that Winnaretta actively sought out living singers and composers who were still searching for their audiences. Today’s international musical glitterati—Maurice Ravel, Claude Debussy, Serge Diaghilev, Frederick Delius, and Igor Stravinsky—owe their first successes to Winnaretta, Princesse de Polignac, and her salon. Yet, for Florence, it was the princess’s interest in Marcel Proust’s composer and singer lover, Reynaldo Hahn, that struck a chord. Winnaretta worked tirelessly to bring Hahn’s music to public acclaim. Hahn had set poems written by Verlaine and Robert Louis Stevenson to his music in his "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Études latines")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Le ruban dénoué")]), _vm._v(", and he repeatedly performed at Winnaretta’s salon as pianist and singer. Since Winnaretta took on neglected composers, perhaps she could also discover Florence and her voice?"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-9",
      "id": "notes-ch3_9"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Florence saw further attractions to Winnaretta’s salon, too. She promoted writers and artists. The young Jean Cocteau, later one of Florence’s great friends, made early appearances at the salon, where he met the influential Marcel Proust. D. H. Lawrence was personally championed, too, in London for the Polignac Prize, awarded annually by the Royal Society of Literature."), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-19024-7",
      "id": "footnote-19024-7-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Florence, looking to establish herself in high society, might have reflected on the rumors that Winnaretta was a lesbian, but de Polignac seemed quite different from most who were increasingly uninhibited and set out to shock the world of high society. Hadn’t the young novelist Colette"), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-19024-8",
      "id": "footnote-19024-8-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("†")])]), _vm._v(" abandoned her unscrupulous reporter-satirist husband Henry Gauthier-Villars, known to all as “Willy,” and taken to the stage at the Folies Berg"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("è")]), _vm._v("re, performing with her lover, “Missy,” the Marquise de Belbeuf? Didn’t their lingering kisses in the middle of one of their numbers rock Paris? Colette, naturally, went further in her declaration of love for Missy by wearing bracelets engraved with the message “I belong to Missy.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-10",
      "id": "notes-ch3_10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("From everything Florence read, she knew that Winnaretta was sensitive to public opinion. She wanted no scandals. She was discreet and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_36",
      "title": "36"
    }
  }, [_vm._v("took great pains to keep her private life private. Winnaretta used the coded mores of the nobility’s world, and was protected by them: in one’s private life, everything was permitted and possible so long as the unbroken veneer of public life was preserved."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-11",
      "id": "notes-ch3_11"
    }
  }, [_vm._v("11")])]), _vm._v(" So, if the price of fame and fortune meant that Florence had to cozy up to the Princesse de Polignac, perhaps it was worth the effort. First, though, Florence would need to find a way to be discovered by Winnaretta. The question remained: how? Failure was not an option she considered.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ba8887","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 81
// module chunks = 0